import Assistantrobo from './Assistantrobo'

export default Assistantrobo
